var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5V7.21876C13.9989 7.14957 13.9839 7.08129 13.956 7.01796C13.9281 6.95463 13.8878 6.89753 13.8375 6.85001L8.8375 2.30626C8.74533 2.22194 8.62493 2.17517 8.5 2.17517C8.37507 2.17517 8.25467 2.22194 8.1625 2.30626L3.1625 6.85001C3.11219 6.89753 3.07189 6.95463 3.04398 7.01796C3.01607 7.08129 3.00112 7.14957 3 7.21876V13.5",
    stroke: "#1650FF",
    strokeWidth: 1.00635,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 13.5H15.5",
    stroke: "#1650FF",
    strokeWidth: 1.00635,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5V10C10 9.86739 9.94732 9.74021 9.85355 9.64645C9.75979 9.55268 9.63261 9.5 9.5 9.5H7.5C7.36739 9.5 7.24021 9.55268 7.14645 9.64645C7.05268 9.74021 7 9.86739 7 10V13.5",
    stroke: "#1650FF",
    strokeWidth: 1.00635,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHouse);
export default __webpack_public_path__ + "static/media/iconHouse.9c40cc5423269d6acf3c25bdc06634a9.svg";
export { ForwardRef as ReactComponent };